import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "svgIcon-add",
  "use": "svgIcon-add-usage",
  "viewBox": "0 0 93.934 93.934",
  "content": "<symbol viewBox=\"0 0 93.934 93.934\" xmlns=\"http://www.w3.org/2000/svg\" id=\"svgIcon-add\"><path d=\"m46.967 0c-25.939 0-46.967 21.028-46.967 46.967 0 25.939 21.028 46.967 46.967 46.967 25.939 0 46.967-21.027 46.967-46.967 0-25.939-21.028-46.967-46.967-46.967zm27.845 53.924h-20.888v20.889h-13.914v-20.889h-20.889v-13.914h20.889v-20.889h13.914v20.889h20.889v13.914z\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol